// Helpers to compose image URLs on the Cloudflare R2 CDN at
// https://assets.geovinum.io. All helpers return absolute URLs.
// A generated default OG image is used as last-resort fallback.

export const CDN_BASE = "https://assets.geovinum.io";
export const DEFAULT_OG = `${CDN_BASE}/pages/default-og.jpg`;

const PAGE_OG_SLUGS = new Set([
  "home", "maps", "learn", "play", "pro", "journal",
  "legal", "terms", "privacy", "cookies", "refund", "shipping",
]);

// Open-Graph image for a static page. Unknown slugs fall back to the default.
export function pageOg(slug) {
  if (slug && PAGE_OG_SLUGS.has(slug)) return `${CDN_BASE}/pages/${slug}-og.jpg`;
  return DEFAULT_OG;
}

// Per-product imagery (cover / thumb / og). Paths follow the spec:
//   https://assets.geovinum.io/products/{slug}/{cover|thumb|og}.jpg
export function productImages(slug) {
  if (!slug) return { cover: DEFAULT_OG, thumb: DEFAULT_OG, og: DEFAULT_OG };
  return {
    cover: `${CDN_BASE}/products/${slug}/cover.jpg`,
    thumb: `${CDN_BASE}/products/${slug}/thumb.jpg`,
    og: `${CDN_BASE}/products/${slug}/og.jpg`,
  };
}

export function articleImages(slug) {
  if (!slug) return { cover: DEFAULT_OG, thumb: DEFAULT_OG, og: DEFAULT_OG };
  return {
    cover: `${CDN_BASE}/articles/${slug}/cover.jpg`,
    thumb: `${CDN_BASE}/articles/${slug}/thumb.jpg`,
    og: `${CDN_BASE}/articles/${slug}/og.jpg`,
  };
}

// Return the first URL that "looks" usable. If `primary` is a full URL, use it;
// otherwise fall back to the CDN-structured path. Lets us transition from
// geovinum.fr media to R2 without hard-coding image presence.
export function pickImage(...candidates) {
  for (const c of candidates) if (typeof c === "string" && c.trim()) return c;
  return DEFAULT_OG;
}
